import { UseFormRegisterReturn } from "react-hook-form";

interface Props {
    register: UseFormRegisterReturn<string>;
    label: string;
    width: string;
    height: string;
    type?: string;
}

export function InputCreateEmpresaForm({ register, label, width, height, type = "text" }: Props) {
    return (
        <div className="grid">
            <label className="text-sm font-semibold">{label}</label>
            <input 
                {...register}
                className={`${width} ${height} rounded-[3px] border-gray-400 border px-2 
                    font-semibold text-gray-600 text-sm`}
                type={type}/>
        </div>
    );
}
